(function () {
    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        eventDisplayFn(
            module.exports,
            require('../../enums/metrics.js'),
            require('../metrics.js').descriptions,
            require('../data/compareData.js'),
            require('../formatter.js'),
            require('./companyEvents.js'),
            require('diff-match-patch'),
            require('lodash')
        );

    } else {
        RivalIQ.module('utils');
        RivalIQ.utils.eventDisplay = {};

        eventDisplayFn(
            RivalIQ.utils.eventDisplay,
            RivalIQ.enums,
            RivalIQ.metrics.descriptions,
            RivalIQ.data.CompareData,
            RivalIQ.formatter,
            RivalIQ.utils.companyEvents,
            window.diff_match_patch,
            window._
        );
    }

    function eventDisplayFn(eventDisplay, enums, metricDesc, CompareData, formatter, companyEvents, diff_match_patch, _) {

        // these are the types, as proscribed by the server
        eventDisplay.eventTypes = companyEvents.eventType;

        // these are the categories for event types
        eventDisplay.eventCategory = {
            social: 1,
            seo: 2,
            breakout: 3,
            movers: 4,
            // 5 is deprecated
            // 6 is deprecated
            facebookAdsUnderPerforming: 7,
            facebookAdsTopPerformer: 8,
            presenceChange: 9,
            likelyBoostedPost: 10,
            // 11 is deprecated
            listening: 12
        };

        // these are the details for those categories
        eventDisplay.eventCategoryDetails = {};

        eventDisplay.eventCategoryDetails[eventDisplay.eventCategory.social] = {
            name: 'Social Changes'
        };

        eventDisplay.eventCategoryDetails[eventDisplay.eventCategory.seo] = {
            name: 'Search Engine Optimization (SEO) Changes'
        };

        eventDisplay.eventCategoryDetails[eventDisplay.eventCategory.breakout] = {
            name: 'Breakout Posts'
        };

        eventDisplay.eventCategoryDetails[eventDisplay.eventCategory.movers] = {
            name: 'Big Metric Moves'
        };

        eventDisplay.eventCategoryDetails[eventDisplay.eventCategory.facebookAdsUnderPerforming] = {
            name: 'Underperformer'
        };

        eventDisplay.eventCategoryDetails[eventDisplay.eventCategory.facebookAdsTopPerformer] = {
            name: 'Top Performer'
        };

        eventDisplay.eventCategoryDetails[eventDisplay.eventCategory.presenceChange] = {
            name: 'Social Handle Change'
        };

        eventDisplay.eventCategoryDetails[eventDisplay.eventCategory.likelyBoostedPost] = {
            name: 'Notable Likely Boosted Posts'
        };

        eventDisplay.eventCategoryDetails[eventDisplay.eventCategory.listening] = {
            name: 'Social Listening Alerts'
        };

        // these are the details that correspond to those event types
        eventDisplay.eventDetails = {};

        // eventDisplay.eventDetails[eventDisplay.eventTypes.webPageContentChange] = {
        //     description: 'Web Page Change',
        //     source: enums.sources.WEB
        // };

        eventDisplay.eventDetails[eventDisplay.eventTypes.webPageTitleChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Title',
            description: 'Web Page Title Change',
            source: enums.sources.WEB,
            category: eventDisplay.eventCategory.seo
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.webPageMetaDescriptionChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Meta Description',
            description: 'Web Page Meta Description Change',
            source: enums.sources.WEB,
            category: eventDisplay.eventCategory.seo
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.webPageMetaKeywordsChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Meta Keywords',
            description: 'Web Page Meta Keywords Change',
            source: enums.sources.WEB,
            category: eventDisplay.eventCategory.seo
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.twitterDescriptionChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Bio',
            description: 'Twitter Bio Change',
            source: enums.sources.TWITTER,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.twitterNameChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Name',
            description: 'Twitter Name Change',
            source: enums.sources.TWITTER,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.twitterHandleChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Handle',
            description: 'Twitter Handle Change',
            source: enums.sources.TWITTER,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.facebookDescriptionChange] = {
            hasTextDiff: true,
            textDiffSubject: 'About',
            description: 'Facebook About Change',
            source: enums.sources.FACEBOOK,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.facebookUsernameChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Username',
            description: 'Facebook Username Change',
            source: enums.sources.FACEBOOK,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.youTubeDescriptionChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Overview',
            description: 'YouTube Overview Change',
            source: enums.sources.YOUTUBE,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.youTubeTitleChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Title',
            description: 'YouTube Title Change',
            source: enums.sources.YOUTUBE,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.youTubeKeywordsChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Keywords',
            description: 'YouTube Keywords Change',
            source: enums.sources.YOUTUBE,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.instagramDescriptionChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Bio',
            description: 'Instagram Bio Change',
            source: enums.sources.INSTAGRAM,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.instagramNameChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Name',
            description: 'Instagram Name Change',
            source: enums.sources.INSTAGRAM,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.instagramWebsiteChange] = {
            hasUrlDiff: true,
            textDiffSubject: 'Bio Link',
            description: 'Instagram Bio Link Change',
            source: enums.sources.INSTAGRAM,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.instagramUsernameChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Username',
            description: 'Instagram Username Change',
            source: enums.sources.INSTAGRAM,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.landscapeBreakoutPost] = {
            hasPostContent: true,
            description: 'Landscape Breakout Post',
            category: eventDisplay.eventCategory.breakout
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.facebookLikelyBoostedPost] = {
            description: 'Notable Likely Boosted Post',
            category: eventDisplay.eventCategory.likelyBoostedPost
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.engagementGrowth] = {
            hasMetric: true,
            description: 'Engagement Growth',
            category: eventDisplay.eventCategory.movers
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.audienceGrowth] = {
            hasMetric: true,
            description: 'Audience Growth',
            category: eventDisplay.eventCategory.movers
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.facebookAdsUnderPerforming] = {
            description: 'Under Performing Facebook Ad',
            source: enums.sources.FACEBOOK_ADS,
            category: eventDisplay.eventCategory.facebookAdsUnderPerforming
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.facebookAdsTopPerformer] = {
            description: 'Top Performing Facebook Ad',
            source: enums.sources.FACEBOOK_ADS,
            category: eventDisplay.eventCategory.facebookAdsTopPerformer
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.presenceDiscovered] = {
            hasMessage: true,
            template: 'New Social Handle',
            category: eventDisplay.eventCategory.presenceChange
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.presenceGone] = {
            hasMessage: true,
            template: 'Deactivated Social Handle',
            category: eventDisplay.eventCategory.presenceChange
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.tiktokNicknameChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Nickname',
            description: 'TikTok Nickname Change',
            source: enums.sources.TIKTOK,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.tiktokDescriptionChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Signature',
            description: 'TikTok Signature Change',
            source: enums.sources.TIKTOK,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.tiktokHandleChange] = {
            hasTextDiff: true,
            textDiffSubject: 'Username',
            description: 'TikTok Handle Change',
            source: enums.sources.TIKTOK,
            category: eventDisplay.eventCategory.social
        };

        eventDisplay.eventDetails[eventDisplay.eventTypes.listeningVolumeChange] = {
            description: 'Listening Volume Change',
            category: eventDisplay.eventCategory.listening
        };

        // retrieves the description of an event type or null if one is not found
        eventDisplay.getDescription = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails ? eventDetails.description : null);
        };

        // return a boolean indicating if this event type has a text diff
        eventDisplay.hasTextDiff = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails ? eventDetails.hasTextDiff : false);
        };

        // return a boolean indicating if this event type has a url diff
        eventDisplay.hasUrlDiff = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails ? eventDetails.hasUrlDiff : false);
        };

        (function () {

            // we need to copy diff_lines_to_chars_ and modify it slightly to look for whitespace
            // rather than \n
            // per: https://code.google.com/p/google-diff-match-patch/wiki/LineOrWordDiffs
            function diffLinesToWords(text1, text2) {
                const lineArray = []; // e.g. lineArray[4] == 'Hello\n'
                const lineHash = {}; // e.g. lineHash['Hello\n'] == 4

                // '\x00' is a valid character, but various debuggers don't like it.
                // So we'll insert a junk entry to avoid generating a null character.
                lineArray[0] = '';

                /**
                 * Split a text into an array of strings.  Reduce the texts to a string of
                 * hashes where each Unicode character represents one line.
                 * Modifies linearray and linehash through being a closure.
                 * @param {string} text String to encode.
                 * @return {string} Encoded string.
                 * @private
                 */
                function diff_linesToCharsMunge_(text) {
                    let chars = '';
                    // Walk the text, pulling out a substring for each line.
                    // text.split('\n') would would temporarily double our memory footprint.
                    // Modifying text would create many large strings to garbage collect.
                    let lineStart = 0;
                    let lineEnd = -1;
                    // Keeping our own length variable is faster than looking it up.
                    let lineArrayLength = lineArray.length;
                    while (lineEnd < text.length - 1) {
                        lineEnd = text.indexOf(' ', lineStart); // changed here, by rival iq
                        if (lineEnd === -1) {
                            lineEnd = text.length - 1;
                        }
                        const line = text.substring(lineStart, lineEnd + 1);
                        lineStart = lineEnd + 1;

                        if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) :
                            (lineHash[line] !== undefined)) {
                            chars += String.fromCharCode(lineHash[line]);
                        } else {
                            chars += String.fromCharCode(lineArrayLength);
                            lineHash[line] = lineArrayLength;
                            lineArray[lineArrayLength++] = line;
                        }
                    }
                    return chars;
                }

                const chars1 = diff_linesToCharsMunge_(text1);
                const chars2 = diff_linesToCharsMunge_(text2);
                return {
                    chars1: chars1,
                    chars2: chars2,
                    lineArray: lineArray
                };
            }

            // Javascript (in the ES5 form) is robustly broken when it comes to Unicode.
            // See https://mathiasbynens.be/notes/javascript-unicode for the gory details.
            //
            // TL;DR version: Unicode characters with code points >= 0x10000 (known as astral
            // characters from the astral code planes) are represented in Javascript by two
            // "characters" -- a high surrogate (0xd800 - 0xdbff) immediately followed by a low
            // surrogate (0xdc00-0xdfff).  Javascript tends to treat these surrogates as normal
            // characters, so String methods such as substr, length, charAt, etc tend to fail badly.
            //
            // Google's diff-match-patch library uses the normal Javascript String class without
            // regard to this issue, so it tends to have problems properly handling astral characters.
            // The problem presents itself as surrogate pairs "split" across diff entries.
            //
            // This routine takes the output of the diff-match-patch library and makes the
            // necessary adjustments so that no astral characters are split across diff entries.
            //
            // TODO: Does this need to handle combining characters as well?

            function fixupAstralCharacters(diffs) {
                let count = diffs.length;

                const isHighSurrogate = function (chCode) {
                    return (chCode >= 0xd800 && chCode <= 0xdbff);
                };

                const isLowSurrogate = function (chCode) {
                    return (chCode >= 0xdc00 && chCode <= 0xdfff);
                };

                for (let i = 0; i < count; i++) {
                    const diff = diffs[i];
                    const action = diff[0];
                    const str = diff[1];
                    let strlen = str.length;
                    let ch;
                    let newChar;

                    if (action === diff_match_patch.DIFF_EQUAL) {
                        // If the current diff entry string ends with a high surrogate, then propagate the surrogate to
                        // any following insert or delete entries.
                        if (strlen > 0) {
                            ch = str.charCodeAt(strlen - 1);

                            if (isHighSurrogate(ch)) {
                                diff[1] = str.substr(0, strlen - 1);
                                strlen -= 1;

                                newChar = String.fromCharCode(ch);

                                if (((i + 1) < count) && (diffs[i + 1][0] === diff_match_patch.DIFF_INSERT || diffs[i + 1][0] === diff_match_patch.DIFF_DELETE)) {
                                    diffs[i + 1][1] = newChar + diffs[i + 1][1];
                                }

                                if (((i + 2) < count) && (diffs[i + 2][0] === diff_match_patch.DIFF_INSERT || diffs[i + 2][0] === diff_match_patch.DIFF_DELETE)) {
                                    diffs[i + 2][1] = newChar + diffs[i + 2][1];
                                }
                            }
                        }

                        // If the current diff entry string starts with a low surrogate, then propagate the surrogate to
                        // any preceding insert or delete entries.
                        if (strlen > 0) {
                            ch = str.charCodeAt(0);

                            if (isLowSurrogate(ch)) {
                                diff[1] = str.substr(1, strlen - 1);
                                strlen -= 1;

                                newChar = String.fromCharCode(ch);

                                if (((i - 1) >= 0) && (diffs[i - 1][0] === diff_match_patch.DIFF_INSERT || diffs[i - 1][0] === diff_match_patch.DIFF_DELETE)) {
                                    diffs[i - 1][1] = diffs[i - 1][1] + newChar;
                                }

                                if (((i - 2) >= 0) && (diffs[i - 2][0] === diff_match_patch.DIFF_INSERT || diffs[i - 2][0] === diff_match_patch.DIFF_DELETE)) {
                                    diffs[i - 2][1] = diffs[i - 2][1] + newChar;
                                }
                            }
                        }

                        // If the resulting entry has no string, remove the entry entirely.
                        if (strlen === 0) {
                            diffs.splice(i, 1);
                            count -= 1;
                            i -= 1;
                        }
                    }
                }
            }

            // this is a private function for determining a word level diff, rather than character level diff
            function wordDiff(text1, text2) {
                const diffMatchPatch = new diff_match_patch();
                const a = diffLinesToWords(text1, text2);
                const lineText1 = a.chars1;
                const lineText2 = a.chars2;
                const lineArray = a.lineArray;

                const diffs = diffMatchPatch.diff_main(lineText1, lineText2, false);

                diffMatchPatch.diff_charsToLines_(diffs, lineArray);
                diffMatchPatch.diff_cleanupSemantic(diffs);
                fixupAstralCharacters(diffs);

                return diffs;
            }

            // retrieves the text diff of an event given its event type or null if one is not found
            eventDisplay.getTextDiff = function (eventTypeId, event, insertMarkupGenerator, deleteMarkupGenerator) {
                const eventData = event.data;

                if ((this.hasTextDiff(eventTypeId) || this.hasUrlDiff(eventTypeId)) && eventData) {
                    if (!insertMarkupGenerator) {
                        insertMarkupGenerator = this.createTextDiffMarkupGenerator('ins');
                    }

                    if (!deleteMarkupGenerator) {
                        deleteMarkupGenerator = this.createTextDiffMarkupGenerator('del');
                    }

                    const diff = wordDiff(eventData.oldValue, eventData.newValue);

                    return _.map(diff, function (tuple) {
                        const type = tuple[0];
                        const value = tuple[1];
                        if (type < 0) {
                            return deleteMarkupGenerator(value);
                        } else if (type > 0) {
                            return insertMarkupGenerator(value);
                        } else {
                            return value;
                        }
                    }).join('');
                }

                return null;
            };

        }());

        // TODO this is some scary scariness that should be controlled
        eventDisplay.createTextDiffMarkupGenerator = function (type, isInline) {
            return function (value) {
                let html = '';

                if (type === 'ins') {
                    html += '<ins';
                    if (isInline) {
                        html += ' style="background:#E6FFE6;"';
                    }
                    html += '>';
                } else {
                    html += '<del';
                    if (isInline) {
                        html += ' style="background:#FFE6E6;"';
                    }
                    html += '>';
                }

                html += value;

                if (type === 'ins') {
                    html += '</ins>';
                } else {
                    html += '</del>';
                }

                // if we have an empty diff value then don't show an ins/del
                return (value.length) ? html : value;
            };
        };

        // retrieves the text diff with inline styling of an event given its event type or null if one is not found
        eventDisplay.getInlineTextDiff = function (eventTypeId, event) {
            return this.getTextDiff(eventTypeId, event, this.createTextDiffMarkupGenerator('ins', true), this.createTextDiffMarkupGenerator('del', true));
        };

        eventDisplay.getInlineDeleteTextDiff = function (eventTypeId, event) {
            return this.getTextDiff(eventTypeId, event, function () { return ''; }, this.createTextDiffMarkupGenerator('del', true));
        };

        eventDisplay.getInlineInsertTextDiff = function (eventTypeId, event) {
            return this.getTextDiff(eventTypeId, event, this.createTextDiffMarkupGenerator('ins', true), function () { return ''; });
        };

        eventDisplay.getTemplate = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return _.result(eventDetails, 'template');
        };

        // retrieves the text diff subject of an event given its event type or null if one is not found
        eventDisplay.getTextDiffSubject = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails ? eventDetails.textDiffSubject : null);
        };

        // return a boolean indicating if this event type has post content
        eventDisplay.hasPostContent = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails ? eventDetails.hasPostContent : false);
        };

        // return a boolean indicating if this event type has message content
        eventDisplay.hasMessage = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails ? eventDetails.hasMessage : false);
        };

        eventDisplay.hasFacebookAdContent = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails.source === enums.sources.FACEBOOK_ADS);
        };

        eventDisplay.hasLikelyBoostedPosts = function (eventTypeId) {
            return (eventTypeId === eventDisplay.eventTypes.facebookLikelyBoostedPost);
        };

        eventDisplay.isListeningEvent = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails.category === eventDisplay.eventCategory.listening);
        };

        // retrieves the post content of an event given its event type or null if one is not found
        eventDisplay.getPostContent = function (eventTypeId, event) {
            const data = event.data;

            if (this.hasPostContent(eventTypeId)) {
                if (event.company_icon_url) {
                    data.company_icon_url = event.company_icon_url;
                }

                return data;
            }

            return null;
        };

        // return a boolean indicating if this event type has a metric
        eventDisplay.hasMetric = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails ? eventDetails.hasMetric : false);
        };

        // TODO deprecated
        // retrieves the metric of an event given its event type or null if one is not found
        eventDisplay.getMetric = function (eventTypeId, event) {
            const data = event.data;
            const compareData = new CompareData();

            if (this.hasMetric(eventTypeId)) {
                if (data && data.concept) {
                    data.icon_url = compareData.getMetricIconUrl(data.concept);
                    data.category = compareData.getMetricCategory(data.concept);

                    const source = compareData.getMetricSource(data.concept);

                    if (source !== null && source !== void(0)) {
                        const sourceDetails = compareData.getSourceDetails(source);

                        if (sourceDetails !== null && sourceDetails !== void(0)) {
                            data.channel = sourceDetails.channel;
                        }
                    }
                }

                return data;
            }

            return null;
        };

        // returns a boolean indicating if this event type and event are for engagement
        eventDisplay.isEngagementMetric = function (eventTypeId, event) {
            const concept = _.get(event, ['data', 'concept']);
            if (concept) {
                return _.find(metricDesc, {
                    id: concept
                }).category === enums.category.ENGAGEMENT;
            }
            return false;
        };

        // retrieves the source of an event given its event type or null if one is not found
        eventDisplay.getSource = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails ? eventDetails.source : null);
        };

        // retrieves the source details of an event given its event type or null if one is not found
        eventDisplay.getSourceDetails = function (eventTypeId) {
            const source = this.getSource(eventTypeId);

            if (source !== null && source !== void(0)) {
                return enums.sourceDetails[source];
            }

            return null;
        };

        eventDisplay.getCategory = function (eventTypeId) {
            const eventDetails = this.eventDetails[eventTypeId];
            return (eventDetails ? eventDetails.category : null);
        };

        eventDisplay.getCategoryDetails = function (category) {
            return (eventDisplay.eventCategoryDetails[category]);
        };

        /**
         * Gets a description preamble for an event.
         * @param eventTypeId
         * @param event
         * @returns {String}
         */
        eventDisplay.getDescriptionPreamble = function (eventTypeId, event) {

            let preamble = null;

            if (eventDisplay.hasMetric(eventTypeId)) {

                preamble = [(eventDisplay.isEngagementMetric(eventTypeId, event) ? 'Grew' : 'Moved'), 'their'];
            } else if (eventDisplay.hasTextDiff(eventTypeId) || eventDisplay.hasUrlDiff(eventTypeId)) {

                preamble = 'Changed their';
            } else if (eventDisplay.hasPostContent(eventTypeId)) {

                preamble = 'Had a';
            }

            return (_.isArray(preamble) ? _.compact(preamble).join(' ') : preamble);
        };

        /**
         * Gets a title for an event.
         * @param eventTypeId
         * @param {Object} event
         * @returns {String}
         */
        eventDisplay.getTitle = function (eventTypeId, event) {

            let title = null;
            let sourceDetails = eventDisplay.getSourceDetails(eventTypeId);
            let category = null;
            let categoryDetails = null;


            if (eventDisplay.hasMetric(eventTypeId)) {

                title = event.data.metricName;
            } else if (eventDisplay.hasTextDiff(eventTypeId) || eventDisplay.hasUrlDiff(eventTypeId)) {

                title = [sourceDetails.name, eventDisplay.getTextDiffSubject(eventTypeId)];
            } else if (eventDisplay.hasPostContent(eventTypeId)) {
                sourceDetails = enums.sourceDetails[event.data.source];
                title = [
                    'Breakout',
                    _.upperFirst(sourceDetails.postName)
                ];
            } else if (eventDisplay.hasLikelyBoostedPosts(eventTypeId)) {
                title = 'Notable Likely Boosted Post';
            } else if (eventDisplay.hasMessage(eventTypeId)) {

                category = eventDisplay.getCategory(eventTypeId);
                categoryDetails = eventDisplay.getCategoryDetails(category);
                const context = {
                    sourceDetails: sourceDetails,
                    categoryDetails: categoryDetails,
                    event: event
                };

                // if an event type has its own template, use it
                const template = eventDisplay.getTemplate(eventTypeId);
                title = (template ? _.template(template)(context) : categoryDetails.description);

            } else if (eventDisplay.hasFacebookAdContent(eventTypeId)) {

                category = eventDisplay.getCategory(eventTypeId);
                categoryDetails = eventDisplay.getCategoryDetails(category);

                // title is a shouty name
                title = (categoryDetails.name ? categoryDetails.name.toUpperCase() : null);
            }

            return (_.isArray(title) ? _.compact(title).join(' ') : title);
        };

        eventDisplay.getKeywordTableHeaders = function (event) {
            // tables aren't wide enough for urls to also be a column, so omit
            const keyword = _.omit(event.data.topNotableKeywords[0], 'url');
            return _.map(_.keys(keyword), function (key) {
                const manyWords = key.split('_');
                if (key === 'position') {
                    return 'Current Position';
                } else {
                    return _.map(manyWords, function (word) {
                        return _.upperFirst(word);
                    }).join(' ');
                }
            });
        };

        /**
         * Gets a description for an event.
         * @param eventTypeId
         * @param {Object} event
         * @returns {String}
         */
        eventDisplay.getDescription = function (eventTypeId, event) {

            let description = null;
            const title = eventDisplay.getTitle(eventTypeId, event);
            const preamble = eventDisplay.getDescriptionPreamble(eventTypeId, event);

            if (eventDisplay.hasMetric(eventTypeId)) {

                description = [
                    preamble,
                    title,
                    'by',
                    formatter.formats.deltaRelative(event.data.deltaRelative)
                ];
            } else if (eventDisplay.hasTextDiff(eventTypeId) || eventDisplay.hasUrlDiff(eventTypeId)) {

                description = [preamble, title];
            } else if (eventDisplay.hasPostContent(eventTypeId)) {

                description = [
                    preamble,
                    title,
                    'with',
                    formatter.formats.abbreviated(event.data.engagement_total),
                    'interactions'
                ];
            } else {

                description = title;
            }

            return (_.isArray(description) ? _.compact(description).join(' ') : description);
        };

        // this function is primarily for ellipsifying urls in email html.
        eventDisplay.ellipsifyKeywordUrl = function (url, tableHeaders) {
            let start = 0;
            // constants here are comfortable lengths for the urls such that we don't wrap or
            // badly squish other columns in a table
            const fourColMaxUrlLength = 42;
            const threeColMaxUrlLength = 52;
            if (url.startsWith('https://www.')) {
                start = 'https://www.'.length;
            } else if (url.startsWith('http://www.')) {
                start = 'https://www.'.length;
            } else if (url.startsWith('https://')) {
                start = 'https://'.length;
            } else if (url.startsWith('http://')) {
                start = 'http://'.length;
            }
            const urlLength = (tableHeaders.length === 4) ? fourColMaxUrlLength : threeColMaxUrlLength;
            return formatter.ellipsify(urlLength, url.substring(start));
        };
    }
})();
